import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../../context/authContext";
import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  SvgIcon,
} from "@mui/material";
import { colors } from "../../../theme/colors";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { CustomBanner } from "./styled";

import vulnerabilityImage from "../../../img/tester/vulnerabilidad-financiera-retos.webp";
import resistanceImage from "../../../img/tester/resistiendo-financiermante-retos-resistiendo.webp";
import prosperityImage from "../../../img/tester/prosperidad-financiera-retos.webp";

import { ReactComponent as MoneySeguro } from "../../../img/tester/svg/efectivo-seguro-aprobado.svg";
import { ReactComponent as MoneyCoins } from "../../../img/tester/svg/dinero-monedas.svg";
import { ReactComponent as ListaUsuarios } from "../../../img/tester/svg/bi-icons-lista-usuario.svg";
import { ReactComponent as Work } from "../../../img/tester/svg/trabajo.svg";
import { ReactComponent as DarDinero } from "../../../img/tester/svg/dar-dinero.svg";
import { ReactComponent as Educativo } from "../../../img/tester/svg/educacion.svg";
import { ReactComponent as Mochila } from "../../../img/tester/svg/mochila.svg";
import { ReactComponent as Wallet } from "../../../img/tester/svg/billetera.svg";
import { ReactComponent as DineroCalculo } from "../../../img/tester/svg/efectivo-calculadora.svg";
import { ReactComponent as Edificio } from "../../../img/tester/svg/edificio-dolar.svg";
import { ReactComponent as MobileDinero } from "../../../img/tester/svg/tablet-dolar.svg";
import { ReactComponent as Maletin } from "../../../img/tester/svg/maletin-efectivo.svg";
import { ReactComponent as PcDinero } from "../../../img/tester/svg/desktop-efectivo.svg";
import { ReactComponent as EquipoFundacion } from "../../../img/tester/svg/equipo-ico-fundacion-bi.svg";

import { FullScreenWrapper } from "../../Entry/styled";
import Header from "../../../components/common/Header";
import Footer from "../../../components/common/Footer";

export default function TestResults({ section1Score, section2Score }) {
  const totalScore = section1Score + section2Score;
  const { idCliente, logout } = useContext(AuthContext);
  const isLoggedIn = !!idCliente;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Función para determinar el perfil
  const getFinancialProfile = (score) => {
    if (score >= 0 && score <= 3.9) return "Vulnerabilidad Financiera";
    if (score >= 4 && score <= 7.9) return "Resistiendo Financieramente";
    if (score >= 8 && score <= 10) return "Próspero Financieramente";
    return "Perfil Financiero";
  };

  // Función para determinar la descrición
  const getProfileDescription = (score) => {
    if (score >= 0 && score <= 3.9) {
      return "Si tu calificación hace referencia a vulnerabilidad financiera, es probable que te encuentres en dificultades para cubrir tus necesidades básicas y enfrentar un gasto imprevisto puede causarte estrés.";
    }
    if (score >= 4 && score <= 7.9) {
      return "Si estas resistiendo financierameienta, seguro cuentas con la capacidad para cubrir necesidades básicas, puedes enfrentar gastos imprevistos moderados a pesar de enfrentar desafíos o cambios en tu situación económica.";
    }
    if (score >= 8 && score <= 10) {
      return "La prosperidad financiera se refiere a una situación en la que tienes estabilidad económica y también confías en tus finanzas presentes y futuras.";
    }
    return "";
  };

  const getProfileDescriptionExtra = (score) => {
    if (score >= 0 && score <= 3.9) {
      return "Si tu calificación hace referencia a vulnerabilidad financiera, es probable que te encuentres en dificultades para cubrir tus necesidades básicas y enfrentar un gasto imprevisto puede causarte estrés";
    }
    if (score >= 4 && score <= 7.9) {
      return "Recuerda que aún con ahorros, ingresos estables y una adecuada gestión del dinero puedes caer en dificultades o comprometer tu estabilidad financiera.";
    }
    if (score >= 8 && score <= 10) {
      return "Esto incluye tener ingresos que superan a los gastos necesarios, tienes la capacidad de ahorrar e invertir para el futuro, y la posibilidad de alcanzar y disfrutar de metas financieras importantes, como comprar una casa, viajar o pensar en la jubilación.";
    }
    return "";
  };

  // Función para determinar el banner
  const getBackgroundImage = (score) => {
    if (score >= 0 && score <= 3.9) return vulnerabilityImage;
    if (score >= 4 && score <= 7.9) return resistanceImage;
    if (score >= 8 && score <= 10) return prosperityImage;
  };

  // Función para determinar los tips financieros
  const getFinancialAdvice = (score) => {
    if (score >= 0 && score <= 3.9) {
      // Consejos para Vulnerabilidad Financiera
      return [
        {
          icon: MoneySeguro,
          text: "Dentro de tu presupuesto mensual, prioriza los gastos esenciales y reduce los no esenciales.",
        },
        {
          icon: MoneyCoins,
          text: "Ahorra de manera consistente, aunque sea una pequeña cantidad cada mes a fin de establecer un fondo de emergencia equivalente a 3 o 6 meses de gastos.",
        },
        {
          icon: Work,
          text: "Busca fuentes adicionales de ingresos, como trabajos freelance o ventas de artículos que no utilices.",
        },
        {
          icon: DarDinero,
          text: "En caso tengas deudas, prioriza pagar aquellas con altas tasas de interés para liberar recursos en caso de emergencias.",
        },
        {
          icon: Educativo,
          text: "Invierte en educación y capacitación para mejorar tus oportunidades laborales.",
        },
        {
          icon: Mochila,
          text: "Por último, asiste a programas de educación financiera.",
        },
      ];
    }

    if (score >= 4 && score <= 7.9) {
      // Consejos para Resistiendo Financieramente
      return [
        {
          icon: MoneySeguro,
          text: "Incluye una categoría para gastos imprevistos en tu presupuesto mensual.",
        },
        {
          icon: MoneyCoins,
          text: "Construye un ahorro autmático, configura transferencias automáticas a tu fondo de emergencias o plan de inversión.",
        },
        {
          icon: Maletin,
          text: "Aumenta la estabilidad financiera y reduce la dependencia de una sola fuente de ingresos. Busca fuentes adicionales de ingresos, debes estar preparado por si tu fuente principal de ingresos desaparece, una buena opción es emprender.",
        },
        {
          icon: DarDinero,
          text: "Identifica tus habilidades y pasatiempos que puedan convertirse en oportunidades de ingresos adicionales.",
        },
        {
          icon: PcDinero,
          text: "Controla el gasto, identifica áreas de ahorro y asegura que se cumplan las metas financieras que te has propuesto.",
        },
        {
          icon: Wallet,
          text: "Mejora tus conocimientos sobre finanzas personales, inversiones y planificación financiera.",
        },
      ];
    }

    if (score >= 8 && score <= 10) {
      // Consejos para Próspero Financieramente
      return [
        {
          icon: Wallet,
          text: "Mantén un control estricto de tus gastos y sigue un presupuesto que refleje tus prioridades y metas financieras.",
        },
        {
          icon: DineroCalculo,
          text: "Establece metas financieras claras y desarrolla un plan para alcanzarlas.",
        },
        {
          icon: Edificio,
          text: "Asegúrate de invertir y hacer crecer tu patrimonio. Crea un plan de inversión en activos financieros (bonos) y no financieros (bienes raíces).",
        },
        {
          icon: DarDinero,
          text: "Aprovecha el interés compuesto y asegura un crecimiento constante de tu patrimonio.",
        },
        {
          icon: MobileDinero,
          text: "Mantente informado sobre tendencias financieras, nuevas oportunidades de inversión y estrategias de gestión del dinero.",
        },
      ];
    }

    // Consejos por defecto
    return [
      {
        icon: MoneySeguro,
        text: "Incluye una categoría para gastos imprevistos en tu presupuesto mensual.",
      },
      {
        icon: MoneyCoins,
        text: "Construye un ahorro automático, configura transferencias automáticas a tu fondo de emergencia.",
      },
      {
        icon: MoneySeguro,
        text: "Busca fuentes adicionales de ingreso para aumentar tu estabilidad financiera.",
      },
    ];
  };

  return (
    <FullScreenWrapper>
      {!isLoggedIn && <Header />}
      <Container maxWidth="lg" sx={{ marginTop: "3rem", marginBottom: "3rem" }}>
        {/* Header de resultados */}
        <Box textAlign="center" sx={{ mb: 6 }}>
          <Typography
            variant="body1"
            sx={{
              color: colors.secondary,
              fontWeight: "600",
              mb: 2,
              fontSize: { xs: "1.5rem", md: "2rem" },
            }}
          >
            Resultados de test:
          </Typography>
          <Typography
            variant="h2"
            sx={{
              color: colors.primary,
              fontSize: { xs: "3.5rem", md: "3rem" },
              mb: 1,
            }}
          >
            {totalScore.toFixed(1)} Puntos
          </Typography>
        </Box>

        <Grid container spacing={6} justifyContent="center">
          {/* Sección 1 */}
          <Grid item xs={12} md={5}>
            <Card
              elevation={2}
              sx={{
                borderRadius: "16px",
                backgroundColor: colors.white.main,
                boxShadow: "0px 1px 4px #15223214;",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0px 1px 4px #15223214;",
                },
                minHeight: "160px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardContent
                sx={{
                  p: 4,
                  "&:last-child": { pb: 4 },
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ flex: 1, pr: 3 }}>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2.5rem" },
                      fontWeight: "700",
                      color: colors.primary,
                      mb: 2,
                      lineHeight: 1,
                    }}
                  >
                    {section1Score.toFixed(0)} Puntos
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      color: colors.secondary,
                      fontSize: "0.9rem",
                      mb: 1,
                      fontWeight: "500",
                    }}
                  >
                    Sección
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "1rem",
                      color: colors.gray.main,
                      lineHeight: 1.4,
                      maxWidth: "280px",
                    }}
                  >
                    ¿Qué tan bien te describen estas declaraciones o situación?
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: 65,
                    height: 65,
                    borderRadius: "50%",
                    backgroundColor: colors.secondary,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <SvgIcon
                    component={ListaUsuarios}
                    inheritViewBox
                    sx={{ fontSize: "2rem" }}
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Sección 2 */}
          <Grid item xs={12} md={5}>
            <Card
              elevation={2}
              sx={{
                borderRadius: "16px",
                backgroundColor: colors.white.main,
                boxShadow: "0px 1px 4px #15223214;",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0px 1px 4px #15223214;",
                },
                minHeight: "160px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardContent
                sx={{
                  p: 4,
                  "&:last-child": { pb: 4 },
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ flex: 1, pr: 3 }}>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2.5rem" },
                      fontWeight: "700",
                      color: colors.primary,
                      mb: 2,
                      lineHeight: 1,
                    }}
                  >
                    {section2Score.toFixed(1)} Puntos
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      color: colors.secondary,
                      fontSize: "0.9rem",
                      mb: 1,
                      fontWeight: "500",
                    }}
                  >
                    Sección
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "1rem",
                      color: colors.gray.main,
                      lineHeight: 1.4,
                      maxWidth: "280px",
                    }}
                  >
                    ¿Con qué frecuencia se aplica a usted las siguientes
                    declaraciones?
                  </Typography>
                </Box>

                <Box
                  sx={{
                    width: 65,
                    height: 65,
                    borderRadius: "50%",
                    backgroundColor: colors.secondary,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <SvgIcon
                    component={ListaUsuarios}
                    inheritViewBox
                    sx={{ fontSize: "2rem" }}
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Sección del Perfil Financiero */}
        <Box sx={{ mt: 8, mb: 6 }}>
          <Box textAlign="center" sx={{ mb: 4 }}>
            <Typography
              variant="h4"
              sx={{
                color: colors.secondary,
                fontWeight: "400",
                mb: 1,
                fontSize: { xs: "1.5rem", md: "2rem" },
              }}
            >
              Perfil:
            </Typography>
            <Typography
              variant="h2"
              sx={{
                color: colors.primary,
                fontSize: { xs: "1.8rem", md: "2.3rem" },
              }}
            >
              {getFinancialProfile(totalScore)}
            </Typography>
          </Box>
        </Box>

        {/* Banner del perfil */}
        <CustomBanner
          backgroundImage={getBackgroundImage(totalScore)}
        ></CustomBanner>

        <Grid
          container
          spacing={{ xs: 2, sm: 4, md: 6, lg: 10 }}
          justifyContent="center"
          marginTop="1rem"
          marginBottom="2.75rem"
        >
          <Grid item xs={12} md={4}>
            <Card
              elevation={2}
              sx={{
                borderRadius: "8px",
                backgroundColor: colors.white.main,
                boxShadow: "0px 1px 4px #15223214;",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0px 1px 4px #15223214;",
                },
                minHeight: "160px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardContent
                sx={{
                  p: "25px 17px",
                  "&:last-child": { pb: 4 },
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ flex: 1, pr: 3 }}>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      color: colors.primary,
                      mb: "1rem",
                      lineHeight: "35px",
                    }}
                  >
                    60%
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "1rem",
                      color: colors.gray.main,
                      lineHeight: "24px",
                    }}
                  >
                    Globalmente personas con Vulnerabilidad Financiera
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: 55,
                    height: 55,
                    borderRadius: "50%",
                    backgroundColor: colors.orange.secondary,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <SvgIcon
                    component={EquipoFundacion}
                    inheritViewBox
                    sx={{ fontSize: "1.8rem" }}
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              elevation={2}
              sx={{
                borderRadius: "8px",
                backgroundColor: colors.white.main,
                boxShadow: "0px 1px 4px #15223214;",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0px 1px 4px #15223214;",
                },
                minHeight: "160px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardContent
                sx={{
                  p: "25px 17px",
                  "&:last-child": { pb: 4 },
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ flex: 1, pr: 3 }}>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      color: colors.primary,
                      mb: "1rem",
                      lineHeight: "35px",
                    }}
                  >
                    30%
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "1rem",
                      color: colors.gray.main,
                      lineHeight: "18px",
                    }}
                  >
                    Globalmente personas Resistiendo Financieramente
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: 55,
                    height: 55,
                    borderRadius: "50%",
                    backgroundColor: colors.orange.secondary,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <SvgIcon
                    component={EquipoFundacion}
                    inheritViewBox
                    sx={{ fontSize: "1.8rem" }}
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              elevation={2}
              sx={{
                borderRadius: "8px",
                backgroundColor: colors.white.main,
                boxShadow: "0px 1px 4px #15223214;",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0px 1px 4px #15223214;",
                },
                minHeight: "160px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardContent
                sx={{
                  p: "25px 17px",
                  "&:last-child": { pb: 4 },
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ flex: 1, pr: 3 }}>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      color: colors.primary,
                      mb: "1rem",
                      lineHeight: "35px",
                    }}
                  >
                    10%
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "1rem",
                      color: colors.gray.main,
                      lineHeight: "18px",
                    }}
                  >
                    Globalmente personas con Prosperidad Financiera
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: 55,
                    height: 55,
                    borderRadius: "50%",
                    backgroundColor: colors.orange.secondary,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <SvgIcon
                    component={EquipoFundacion}
                    inheritViewBox
                    sx={{ fontSize: "1.8rem" }}
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Descripción del perfil */}
        <Box sx={{ mt: 4 }}>
          <Box textAlign="left" sx={{ mt: 4 }}>
            <Typography
              variant="body2"
              sx={{
                color: colors.primary,
                fontSize: "1.2rem",
                maxWidth: "600px",
                margin: "0 auto",
                lineHeight: "32px",
                mb: "1.5rem",
                fontWeight: "700",
              }}
            >
              {getProfileDescription(totalScore)}
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: colors.primary,
                fontSize: "1.1rem",
                maxWidth: "600px",
                margin: "0 auto",
                lineHeight: "32px",
              }}
            >
              {getProfileDescriptionExtra(totalScore)}
            </Typography>
          </Box>

          <Box textAlign="center" sx={{ mt: 4 }}>
            <Typography
              variant="h2"
              sx={{
                color: colors.primary,
                fontSize: "1.1rem",
                maxWidth: "1200",
                margin: "3.5rem auto",
                lineHeight: "32px",
              }}
            >
              Te dejamos algunos consejos que puedes aplicar para alcanzar un
              mayor grado de seguridad financiera:
            </Typography>
          </Box>
        </Box>

        {/* Sección de consejos */}
        <Grid
          container
          spacing={{ xs: 2, sm: 4, md: 6, lg: 10 }}
          justifyContent="start"
          marginTop="1rem"
        >
          {getFinancialAdvice(totalScore).map((advice, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                elevation={2}
                sx={{
                  borderRadius: "8px",
                  backgroundColor: colors.white.main,
                  boxShadow: "none",
                  minHeight: "160px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CardContent
                  sx={{
                    p: "25px 25px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: 55,
                      height: 55,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      mb: 2,
                    }}
                  >
                    <SvgIcon
                      component={advice.icon}
                      inheritViewBox
                      sx={{ fontSize: "3rem" }}
                    />
                  </Box>

                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "16px",
                        color: colors.primary,
                        lineHeight: "18px",
                        textAlign: "left",
                      }}
                    >
                      {advice.text}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Sección de iframe */}
        {/* <Box sx={{ mt: 6, textAlign: "center" }}>
          <Box textAlign="center" sx={{ mt: 4 }}>
            <Typography
              variant="body2"
              sx={{
                color: colors.primary,
                fontSize: "2rem",
                maxWidth: "1200",
                fontWeight: "bold",
                margin: "3.5rem auto",
                lineHeight: "32px",
              }}
            >
              Te ayudaremos a seguir adelante
            </Typography>
          </Box>
          <iframe
            src="https://formulariosdigitalesqa.bi.com.gt/#/render/GT%20-%20BM%20-%20API%20-%20QA%20-%20PRUEBA%20CENTRO%20DE%20INNOVACION%20Y%20EMPRENDIMIENTO"
            width="100%"
            height="1500"
            style={{
              border: "none",
              borderRadius: "8px",
            }}
            title="Contenido adicional"
            loading="lazy"
          />
        </Box> */}
      </Container>
      {!isLoggedIn && <Footer />}
    </FullScreenWrapper>
  );
}
